// Import Swiper styles
import { observer } from 'mobx-react-lite';
import { Grid, Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/grid';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { ProductAddonListType } from 'core/enums/product-types';
import { Paginator } from 'core/models/paging';
import styles from './carousel.module.scss';
// import 'swiper/css/navigation';

export const Carousel = observer<{
  items: Paginator<any>;
  columnCount?: number;
  type?: ProductAddonListType;
  hasPagination?: boolean;
  navigation?: any;
  navigationArrows?: boolean;
  customNavArrowClass?: string;
}>(
  ({
    items,
    columnCount = 3,
    type,
    hasPagination = true,
    navigation,
    navigationArrows = false,
    customNavArrowClass,
  }) => {
  const pagination = {
    clickable: true,
    renderBullet: (index?: number, className?: string) => {
      return `<div class="${styles.dots} ${className}"></div>`;
    },
  };

  const hasNavigation = items.pages.length > columnCount;

  return (
    <div className={`${styles.carouselContainer}`}>
      <Swiper
        spaceBetween={15}
        slidesPerView={type === ProductAddonListType.LongRow ? 1 : columnCount}
        breakpoints={
          type === ProductAddonListType.LongRow
            ? {
                360: {
                  width: 768,
                  slidesPerView: 5,
                },
              }
            : undefined
        }
        modules={[Grid, Navigation, Pagination]}
        pagination={hasPagination && pagination}
        navigation={navigation || hasNavigation}
        slidesPerGroup={1}
        grabCursor={true}
        className={`${hasNavigation ? styles.hasNav : ''} ${styles.carouselWrapper}`}
      >
        {navigationArrows && <div className={`${customNavArrowClass} swiper-button-prev`} />}
        {items.pages.map((val, pageIndex) => (
          <SwiperSlide className={`${styles.swiperSlide} swiper-col-${columnCount}`} key={`carousel-page_${pageIndex}`}>
            {val.items.map((item, itemIndex) => (
              <div className={styles.swiperSlideInner} key={`carousel-item_${itemIndex}`}>
                {item}
              </div>
            ))}
          </SwiperSlide>
        ))}
        {navigationArrows && <div className={`${customNavArrowClass} swiper-button-next`} />}
      </Swiper>
    </div>
  );
});